import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeeConcessionLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'FeeConcession' */ './components/FeeConcession'
		)
);

export default (store) => {
	return {
		path: 'fee-concession/:campusId?',
		element: <AsyncLoading component={<FeeConcessionLazy />} />,
	};
};
